import React, { useEffect } from 'react';
import { useRef } from 'react';

// --- Animated Section Component ---
const AnimatedSection = ({ children, id, className = "py-20" }) => {
    const sectionRef = useRef(null);
    useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add("is-visible");
                    observer.unobserve(entry.target);
                }
            });
        }, { threshold: 0.1 });
        if (sectionRef.current) observer.observe(sectionRef.current);
        return () => { if (sectionRef.current) observer.unobserve(sectionRef.current); };
    }, []);
    return <section ref={sectionRef} id={id} className={`fade-in-section ${className}`}>{children}</section>;
};


export default AnimatedSection;